import React, { useContext, useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
// import { useNavigate, Link } from "react-router-dom";
import { AppContext } from "../utilities/context";
import Container from "@mui/material/Container";
import Layout from "./Layout";

const Privacy = () => {
  const intl = useIntl();
  const context = useContext(AppContext);
  const lastUpdate = "2024-11-13";
  const contactEmail = "info@qrdoor.click";
  const country = "Argentina";

  useEffect(() => {
    if (context) {
      context.updateBreadcrumbsState(
        [
          { label: intl.formatMessage({ id: "app.header.home.label" }), url: "/" },
          { label: intl.formatMessage({ id: "app.header.help.label" }), url: "/help" },
        ]
      );
    }
  }, []);

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={2}>
          {/* Title */}
          <Grid item xs={12}>
            <Typography variant="h6" component="div">
              <FormattedMessage id="app.privacy.title" />
            </Typography>
          </Grid>
          {/* Last Update */}
          <Grid item xs={12}>
            <Typography variant="body2">
              <FormattedMessage id="app.privacy.lastUpdate" values={{lastUpdate:lastUpdate}} />
            </Typography>
          </Grid>
          {/* Introduction */}
          <Grid item xs={12}>
            <Typography variant="body1">
              <FormattedMessage id="app.privacy.introduction" />
            </Typography>
          </Grid>
          {/* Information We Collect */}
          <Grid item xs={12}>
            <Typography variant="h6">
              <FormattedMessage id="app.privacy.dataCollection.title" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.privacy.dataCollection.usageData" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.privacy.dataCollection.messagingData" />
            </Typography>
          </Grid>
          {/* Use of Information */}
          <Grid item xs={12}>
            <Typography variant="h6">
              <FormattedMessage id="app.privacy.dataUsage.title" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.privacy.dataUsage.purpose" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.privacy.dataUsage.limits" />
            </Typography>
          </Grid>
          {/* Data Retention and Deletion */}
          <Grid item xs={12}>
            <Typography variant="h6">
              <FormattedMessage id="app.privacy.dataRetention.title" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.privacy.dataRetention.policy" />
            </Typography>
          </Grid>
          {/* Data Security */}
          <Grid item xs={12}>
            <Typography variant="h6">
              <FormattedMessage id="app.privacy.dataSecurity.title" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.privacy.dataSecurity.measures" />
            </Typography>
          </Grid>
          {/* Your Rights */}
          <Grid item xs={12}>
            <Typography variant="h6">
              <FormattedMessage id="app.privacy.userRights.title" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.privacy.userRights.access" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.privacy.userRights.rectification" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.privacy.userRights.deletion" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.privacy.userRights.contact" values={{contactEmail:contactEmail}} />
            </Typography>
          </Grid>
          {/*  Changes to this Privacy Policy */}
          <Grid item xs={12}>
            <Typography variant="h6">
              <FormattedMessage id="app.privacy.policyChanges.title" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.privacy.policyChanges.text" />
            </Typography>
          </Grid>
          {/* Contact */}
          <Grid item xs={12}>
            <Typography variant="h6">
              <FormattedMessage id="app.privacy.contact.title" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.privacy.contact.text" values={{contactEmail:contactEmail}} />
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default Privacy;
